import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { getBackgroundColor, getBorder, getFocusRingStyles, getSlideHoverStyles, toggleTheme } from "./toggleTheme";
export var Slide = withFocusToggleClassName(styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n    box-sizing: border-box;\n    cursor: ", ";\n    display: flex;\n    flex-shrink: 0;\n    justify-content: space-between;\n    align-items: center;\n\n    &:active span {\n        ", "\n    }\n\n    transition: ", ";\n\n    // Needed for the outline component.\n    position: relative;\n\n    ", ";\n\n    ", ";\n"])), getBackgroundColor, getBorder, function (_ref) {
  var size = _ref.size,
    themeMode = _ref.themeMode;
  return toggleTheme.height[size](themeMode);
}, function (_ref2) {
  var size = _ref2.size,
    themeMode = _ref2.themeMode;
  return toggleTheme.height[size](themeMode);
}, function (_ref3) {
  var size = _ref3.size,
    themeMode = _ref3.themeMode;
  return toggleTheme.width[size](themeMode);
}, function (props) {
  return props.isDisabled ? "not-allowed" : "pointer";
}, function (_ref4) {
  var size = _ref4.size,
    themeMode = _ref4.themeMode,
    isChecked = _ref4.isChecked;
  return themeMode === "ursa-light" && "\n            width: ".concat(toggleTheme.handleSize[size](themeMode) + 4, "px;\n            border-radius: ").concat(toggleTheme.height[size](themeMode), ";\n            margin-left: ").concat(toggleTheme.handleMargin[size](themeMode) - (isChecked ? 4 : 0), "px;\n        ");
}, function (_ref5) {
  var themeMode = _ref5.themeMode;
  return toggleTheme.motion.default(themeMode);
}, getSlideHoverStyles, function (_ref6) {
  var isFocused = _ref6.isFocused,
    size = _ref6.size,
    themeMode = _ref6.themeMode;
  return isFocused && getFocusRingStyles({
    size: size,
    themeMode: themeMode
  });
}));
Slide.displayName = "Slide";
//# sourceMappingURL=Slide.js.map